import {Injectable} from '@angular/core';
import {of} from 'rxjs';
import {ScriptStore} from "../models/script-loader-store";

declare let document: any;

@Injectable()
export class ScriptService {

  private scripts: any = {};

  constructor() {
    ScriptStore.forEach((script: any) => {
      this.scripts[script.name] = {
        loaded: false,
        src: script.src
      };
    });
  }

  load(...scripts: string[]): any {
    const promises: any[] = [];
    scripts.forEach((script) => {
      promises.push(this.loadScript(script));
    });
    return Promise.all(promises);
  }

  loadScript(name: string): Promise<any> {

    return new Promise((resolve, reject) => {
      // resolve if already loaded
      if (this.scripts[name].loaded) {
        resolve({script: name, loaded: true, status: 'Already Loaded'});
      } else {
        // load script
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = this.scripts[name].src;
        if (script.readyState) {  // IE
          script.onreadystatechange = () => {
            if (script.readyState === 'loaded' || script.readyState === 'complete') {
              script.onreadystatechange = null;
              this.scripts[name].loaded = true;
              resolve({script: name, loaded: true, status: 'Loaded'});
            }
          };
        } else { // Others
          script.onload = () => {
            this.scripts[name].loaded = true;
            resolve({script: name, loaded: true, status: 'Loaded'});
          };
        }
        script.onerror = (error: any) => resolve({script: name, loaded: false, status: 'Loaded'});
        document.getElementsByTagName('head')[0].appendChild(script);
      }
    });
  }

  verifyIfScriptIsLoaded(name: string): any {
    console.log(this.scripts[name]);
    if (this.scripts[name].loaded) {
      console.log('loaded');
      return of(true);
    }
    console.log('load failed');
    return of(false);
  }
}

